import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { ActionsFiltersStore } from '@/contexts/action-plans/ActionPlans.interfaces'

export const useActionsFiltersStore = defineStore(
  'actions-filters',
  () => {
    const actionsFilters = ref<ActionsFiltersStore[]>([])

    const updateActionsFilters = (newFilters: ActionsFiltersStore) => {
      const filterIndex = actionsFilters.value.findIndex(
        (storeFilter) =>
          storeFilter.actionPlanId === newFilters.actionPlanId && storeFilter.customerId === newFilters.customerId
      )

      if (filterIndex >= 0) {
        actionsFilters.value.splice(filterIndex, 1, newFilters)
      } else {
        actionsFilters.value.push(newFilters)
      }
    }

    const getActionsFiltersById = (actionPlanId: string, customerId: number): ActionsFiltersStore | null => {
      return (
        actionsFilters.value.find(
          (storedFilter) => storedFilter.actionPlanId === actionPlanId && storedFilter.customerId === customerId
        ) ?? null
      )
    }

    const removeActionsFiltersById = (actionPlanId: string, customerId: number) => {
      actionsFilters.value = actionsFilters.value.filter(
        (storedFilter) => !(storedFilter.actionPlanId === actionPlanId && storedFilter.customerId === customerId)
      )
    }

    function $reset() {
      actionsFilters.value = []
    }

    return { actionsFilters, updateActionsFilters, getActionsFiltersById, removeActionsFiltersById, $reset }
  },
  { persist: true }
)
